import { Mutate } from '@model/mutate';
import { Globals } from '@theme/utils/globals';
import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { VALIDATION } from '@theme/utils/functions';
import { MutateService } from '@service/mutate/mutate.service';
import {EmitterService} from '@service/emitter/emitter.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MutateAddComponent } from '@client/mutate/mutate-add/mutate-add.component';

@Component({
  selector: 'app-mutate-show',
  templateUrl: './mutate-show.component.html',
  styleUrls: ['./mutate-show.component.scss']
})
export class MutateShowComponent implements OnInit {
  title: string = ""
  mutate: Mutate
  global = {country: Globals.country, device: Globals.device}
  userSession = Globals.user;
  validation = VALIDATION
  validate = false;

  constructor(
    public modale: NgbActiveModal,
    private modalService: NgbModal,
    private emitter: EmitterService,
    private mutateService: MutateService
  ) {
    this.validate = this.mutateService.validated
    this.mutate = this.mutateService.getMutate()
    this.title = "Détails de la mutation du dossier de " + this.mutate?.folder?.customer?.nom
  }

  ngOnInit(): void {
  }

  editMutate(row) {
    this.modalService.dismissAll()
    this.mutateService.setMutate(row)
    this.mutateService.edit = true
    this.modal(MutateAddComponent, 'modal-basic-title', 'xl', true, 'static')
  }

  printerMutate(row): void {
    this.mutateService.getPrinter('SHOW', this.userSession?.agencyKey, this.userSession?.uuid, row?.uuid);
  }
  validateMutate(row){
    Swal.fire({
      title: '',
      text: 'Voulez-vous vraiment valider cet enrégistrement ?',
      showCancelButton: true,
      showCloseButton: true,
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Valider <i class="fas fa-check"></i>',
      confirmButtonColor: 'green',
      timer: 2500,
      reverseButtons: true
    }).then((willDelete) => {
      if (willDelete.dismiss) {
      } else {
      this.mutateService.validate(row).subscribe(res => {
        if (res?.status === 'success') {
          if (row) {
            this.modale.close('ferme');
            this.emitter.emit({action: 'MUTATE_VALIDATE', payload: res?.data});
          }
        }
      });
      }
    });
  }

  modal(component, type, size, center, backdrop) {
    this.modalService.open(component, {
      ariaLabelledBy: type,
      size: size,
      centered: center,
      backdrop: backdrop
    }).result.then((result) => {

    }, (reason) => {

    });
  }
}
